<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Requisitos Legales</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroalcance" :items="alcance" label="Alcance" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtrotipo" :items="tipos" label="Tipo" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Norma" dense v-model="filtronorma">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-select dense v-model="filtroaspectoamb" :items="aspectosamb" label="Aspecto Ambiental"
                                item-text="descr" item-value="codigo"></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Descripción" dense v-model="filtrodescr">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroar" :items="itemsar" label="A/R" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Obligación" dense v-model="filtroobligacion">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroaspecto" :items="aspectos" label="Aspecto"
                                item-text="detalle" item-value="valor"></v-select>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="4000" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:item.ver="{ item }">

                    <v-icon small color="blue" class="mr-2" @click.stop="verInforme(item)">
                        mdi-eye
                    </v-icon>
                    <v-icon small color="blue" class="mr-2" @click.stop="editarInforme(item)">
                        mdi-pencil
                    </v-icon>
                </template>
            </v-data-table>
            <!-- <VerInforme :visible="showInforme" :codgral="editedItem.codgral" @close="showInforme = false"></VerInforme> -->
            <EditarInforme :visible="showEditar" :codgral="editedItem.codgral" @close="showEditar = false">
            </EditarInforme>
            <Visualizardocumentos :visible="showInforme" :codigo="editedItem.codigo" :rutadoc="editedItem.ruta"
                @close="showInforme = false"></Visualizardocumentos>
        </v-app>
    </div>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
// import VerInforme from "../Requisitos/Informe.vue";
import EditarInforme from "../Requisitos/Editar.vue"
import Visualizardocumentos from "../Requisitos/Visualizardocumentos.vue";
import moment from "moment";
export default {
    components: { EditarInforme, Visualizardocumentos },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroalcance: "",
        filtroar: "",
        filtroaspecto: "",
        filtroobligacion: "",
        filtroestado: "A",
        filtronorma: "",
        filtrotipo: "",
        filtroaspectoamb: "",
        filtrodescr: "",
        listado: [],
        aspectosamb: [],
        estado: [{ detalle: "Activas", valor: "A" },
        { detalle: "Inactivas", valor: "I" },
        { detalle: "Todas", valor: "" },
        ],
        tipos: [{ detalle: "Agua", valor: "Agua" },
        { detalle: "Aire", valor: "Aire" },
        { detalle: "Ascensores y Montacargas", valor: "Ascensores y Montacargas" },
        { detalle: "Combustible", valor: "Combustible" },
        { detalle: "Energía", valor: "Energía" },
        { detalle: "Enfermedades No Profesionales", valor: "Enfermedades No Profesionales" },
        { detalle: "Estudios de Impacto Ambiental", valor: "Estudios de Impacto Ambiental" },
        { detalle: "Flora y Fauna", valor: "Flora y Fauna" },
        { detalle: "Matafuegos y Aparatos Sometidos a Presión", valor: "Matafuegos y Aparatos Sometidos a Presión" },
        { detalle: "Medicina Laboral", valor: "Medicina Laboral" },
        { detalle: "Normativa General", valor: "Normativa General" },
        { detalle: "Ordenamiento Territorial", valor: "Ordenamiento Territorial" },
        { detalle: "Organismos", valor: "Organismos" },
        { detalle: "Permisos y Habilitaciones", valor: "Permisos y Habilitaciones" },
        { detalle: "Radicación Industrial", valor: "Radicación Industrial" },
        { detalle: "Radiaciones Electromagnéticas", valor: "Radiaciones Electromagnéticas" },
        { detalle: "Residuos Especiales - Peligrosos", valor: "Residuos Especiales - Peligrosos" },
        { detalle: "Residuos Industriales asimilables a RSU", valor: "Residuos Industriales asimilables a RSU" },
        { detalle: "Ruidos", valor: "Ruidos" },
        { detalle: "Seguridad en la Construcción", valor: "Seguridad en la Construcción" },
        { detalle: "Seguros Ambientales", valor: "Seguros Ambientales" },
        { detalle: "Suelo", valor: "Suelo" },
        { detalle: "Sustancias Químicas", valor: "Sustancias Químicas" },
        { detalle: "Tránsito y Seguridad Vial", valor: "Tránsito y Seguridad Vial" },
        { detalle: "Transporte de Cargas", valor: "Transporte de Cargas" },
        { detalle: "Transporte de Mercancías Peligrosas por Carretera", valor: "Transporte de Mercancías Peligrosas por Carretera" },
        { detalle: "Otro", valor: "Otro" },
        { detalle: "Todos", valor: "" },
        ],
        alcance: [{ detalle: "Nacional", valor: "N" },
        { detalle: "Provincial", valor: "P" },
        { detalle: "Municipal", valor: "M" },
        { detalle: "CABA", valor: "C" },
        { detalle: "Todos", valor: "" },
        ],
        aspectos: [{ detalle: "Medio Ambiente", valor: "M" },
        { detalle: "SST", valor: "S" },
        { detalle: "Otros", valor: "O" },
        { detalle: "Todos", valor: "" },
        ],
        itemsar: [{ detalle: "Aplicable", valor: "A" },
        { detalle: "Referencia", valor: "R" },
        { detalle: "Todos", valor: "" },
        ],
        showInforme: false,
        showEditar: false,
        loadtable: false,
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codigo",
            },
            { text: "Norma", value: "norma", sortable: false },
            { text: "Organismo Emisor", value: "emisor", sortable: false },
            { text: "Alcance", value: "alcance", align: "center", sortable: false },
            { text: "Descripción", value: "descr", align: "center", sortable: false },
            { text: "A/R", value: "ar", align: "center", sortable: false },
            { text: "Autoridad de Aplicación", value: "autoridad", align: "center", sortable: false },
            { text: "Observaciones", value: "observ", align: "center", sortable: false },
            { text: "Obligaciones", value: "oblig", sortable: false },
            { text: "Aspecto Ambiental", value: "aspectoamb", align: "center", sortable: false },
            { text: "Estado", value: "estado", align: "center", sortable: false },
            { text: "Ver / Editar", value: "ver", align: "center", width: "5%", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                this.cargaraspectosamb();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        verInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showInforme = true;
        },
        editarInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        cargaraspectosamb() {
            let self = this;
            axios
                .get("/Sgi/Aspectosambientales?")
                .then((response) => {
                    self.aspectosamb = response.data;
                })
                .catch((error) => {
                    self.aspectosamb = [];
                    console.log(error);
                });
        },

        cargarListado() {
            this.loadtable = true;
            const estado = this.filtroestado;
            const alcance = this.filtroalcance;
            const aspecto = this.filtroaspecto;
            const aspectoamb = this.filtroaspectoamb;
            const obligacion = this.filtroobligacion;
            const descr = this.filtrodescr;
            const norma = this.filtronorma;
            const tipo = this.filtrotipo;
            const ar = this.filtroar;

            let self = this;
            axios
                .get("/Sgi/ListadoRequisitos?", {
                    params: {
                        estado: estado,
                        obligacion: obligacion,
                        norma: norma,
                        tipo: tipo,
                        descr: descr,
                        alcance: alcance,
                        aspecto: aspecto,
                        aspectoamb: aspectoamb,
                        ar: ar,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>